import { Link } from 'react-router-dom';

export default function TransparenzPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Transparenz
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Verantwortung sichtbar machen.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Transparenz ist die Grundlage für Vertrauen. Wir machen nachvollziehbar, 
              wie asK-mi arbeitet, wie Fördermittel eingesetzt werden und welche Wirkung entsteht.
            </p>
          </div>
        </div>
      </section>

      {/* Der Verein */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
                Der Verein
              </span>
              <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
                ASK-MI e.V.
              </h2>
              <div className="bg-[#FAF9F7] rounded-2xl p-8 border border-[#E8E4DE]">
                <dl className="space-y-4">
                  <div>
                    <dt className="text-sm text-gray-500 mb-1">Vollständiger Name</dt>
                    <dd className="text-gray-900 font-medium">
                      ASK-MI – Verein für Jugendförderung, Erwachsenenbildung, Kulturerhalt, Forschung und Entwicklung e.V.
                    </dd>
                  </div>
                  <div className="pt-4 border-t border-[#E8E4DE]">
                    <dt className="text-sm text-gray-500 mb-1">Sitz</dt>
                    <dd className="text-gray-900">Ettlingen</dd>
                  </div>
                  <div className="pt-4 border-t border-[#E8E4DE]">
                    <dt className="text-sm text-gray-500 mb-1">Notarielle Gründung</dt>
                    <dd className="text-gray-900">06. Februar 2026</dd>
                  </div>
                  <div className="pt-4 border-t border-[#E8E4DE]">
                    <dt className="text-sm text-gray-500 mb-1">Mitgliedsbeiträge</dt>
                    <dd className="text-gray-900">Keine</dd>
                  </div>
                  <div className="pt-4 border-t border-[#E8E4DE]">
                    <dt className="text-sm text-gray-500 mb-1">Ausrichtung</dt>
                    <dd className="text-gray-900">Gemeinnützig</dd>
                  </div>
                </dl>
              </div>
            </div>

            <div>
              <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
                Förderzweck
              </span>
              <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
                Wofür wir stehen
              </h2>
              <div className="space-y-4">
                <div className="bg-white border border-[#E8E4DE] rounded-xl p-6 hover:border-[#C4A962] transition-colors">
                  <h3 className="font-semibold text-gray-900 mb-2">Jugendförderung</h3>
                  <p className="text-gray-600 text-sm">
                    Unterstützung junger Menschen ab 14 Jahren, insbesondere aus dem neurodiversen Spektrum.
                  </p>
                </div>
                <div className="bg-white border border-[#E8E4DE] rounded-xl p-6 hover:border-[#C4A962] transition-colors">
                  <h3 className="font-semibold text-gray-900 mb-2">Erwachsenenbildung</h3>
                  <p className="text-gray-600 text-sm">
                    Wissen und Kompetenzen für Familien, Fachkräfte und Begleiter.
                  </p>
                </div>
                <div className="bg-white border border-[#E8E4DE] rounded-xl p-6 hover:border-[#C4A962] transition-colors">
                  <h3 className="font-semibold text-gray-900 mb-2">Forschung & Entwicklung</h3>
                  <p className="text-gray-600 text-sm">
                    Neue Wege für Neurodiversität, Teilhabe und gesellschaftliche Entwicklung.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Aufbauphase 2026 */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              2026 · Aufbauphase
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight mb-6">
              Jetzt beginnt die Wirkung.
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              asK-mi befindet sich im Aufbau. Die Grundlagen sind geschaffen – 
              jetzt entsteht das Ökosystem für Förderung und Entwicklung.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">✓</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Organisation aufgebaut</h3>
              <p className="text-gray-600 text-sm">
                Der Verein ist gegründet, die rechtliche Struktur steht.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">✓</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Förderstruktur entwickelt</h3>
              <p className="text-gray-600 text-sm">
                Die Förderbereiche und -prozesse sind definiert.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">✓</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Fördermodell etabliert</h3>
              <p className="text-gray-600 text-sm">
                Das Prinzip: Förderer → asK-mi → gezielte Unterstützung → Wirkung.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">✓</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Erste Unterstützer gewonnen</h3>
              <p className="text-gray-600 text-sm">
                Partnerschaften mit Menschen und Unternehmen, die Verantwortung übernehmen.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">✓</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Digitale Infrastruktur aufgebaut</h3>
              <p className="text-gray-600 text-sm">
                Die Plattform für Information, Dialog und zukünftige Funktionen steht.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-dashed border-[#E8E4DE]">
              <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center mb-5">
                <span className="text-xl">→</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Nächste Schritte</h3>
              <p className="text-gray-600 text-sm">
                Erste Förderprojekte starten, Wirkung dokumentieren, Netzwerk erweitern.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mittelverwendung */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Mittelverwendung & Wirkung
            </span>
            <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
              Transparente Berichterstattung
            </h2>
            
            <div className="bg-[#FAF9F7] rounded-2xl p-8 md:p-12 border border-[#E8E4DE] text-left">
              <p className="text-gray-600 leading-relaxed mb-6">
                asK-mi befindet sich im Aufbau. Der Verein veröffentlicht seine Mittelverwendung 
                und Wirkungsdaten transparent, sobald entsprechende Geschäftsjahre bzw. 
                Förderaktivitäten vorliegen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Wir berichten ehrlich und nachvollziehbar – keine geschätzten Zahlen, 
                keine künstlichen Erfolgsmeldungen. Transparenz bedeutet für uns auch, 
                offen zu sagen, wo wir noch am Anfang stehen.
              </p>
              
              <div className="border-t border-[#E8E4DE] pt-8">
                <h3 className="font-semibold text-gray-900 mb-4">Zukünftige Berichte</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center gap-3 text-gray-600">
                    <span className="text-[#C4A962]">📊</span>
                    <span className="text-sm">Jahresberichte</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <span className="text-[#C4A962]">📋</span>
                    <span className="text-sm">Förderprojekt-Übersichten</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <span className="text-[#C4A962]">💰</span>
                    <span className="text-sm">Finanzberichte</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <span className="text-[#C4A962]">📈</span>
                    <span className="text-sm">Wirkungsberichte</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Grundsätze */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Unsere Grundsätze
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Wie wir Transparenz leben.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-white border border-[#E8E4DE] flex items-center justify-center mx-auto mb-5">
                <span className="text-2xl">🔍</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Offenheit</h3>
              <p className="text-gray-600 leading-relaxed">
                Alle relevanten Informationen sind für Förderer und Interessierte zugänglich.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-white border border-[#E8E4DE] flex items-center justify-center mx-auto mb-5">
                <span className="text-2xl">✅</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Nachvollziehbarkeit</h3>
              <p className="text-gray-600 leading-relaxed">
                Jede Förderung und Mittelverwendung wird dokumentiert und berichtet.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-white border border-[#E8E4DE] flex items-center justify-center mx-auto mb-5">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Dialog</h3>
              <p className="text-gray-600 leading-relaxed">
                Förderer erhalten regelmäßige Updates und können jederzeit Fragen stellen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[42px] font-bold tracking-tight mb-6">
            Fragen zur Transparenz?
          </h2>
          <p className="text-lg text-white/70 max-w-xl mx-auto mb-10">
            Wir stehen für offene Kommunikation. Kontaktieren Sie uns bei Fragen 
            zur Organisation, Mittelverwendung oder unserer Arbeit.
          </p>
          <Link 
            to="/kontakt"
            className="inline-flex items-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
          >
            Kontakt aufnehmen
          </Link>
        </div>
      </section>
    </div>
  );
}
